import {ActionType} from 'store'

const defaultState = () => ({
    appState: "loading",
    // True when Console still renders Administration sub-tabs itself.
    consoleRendersSubTabs: false
});


export default (state = defaultState(), { type, payload }: ActionType): any => {
    switch (type) {
        case "APP/BOOT:SUCCESS": {
            return { ...state, appState: "ready", isIframe: false }
        }
        case "APP/CONSOLE-SUB-TABS": {
            return { ...state, consoleRendersSubTabs: Boolean(payload?.length) }
        }
        case "APP/MINI-BOOT:SUCCESS": {
            return { ...state, appState: "ready", isIframe: true }
        }
        case "APP/BOOT:FAILED": {
            return { ...state, appState: "failed" }
        }
        case "APP/RELOAD": {
            return { ...state, isReloading: true }
        }
        case "APP/LOAD-WORKLOADS:ERROR": {
            return { ...state, appState: "failed" }
        }
        default: {
            return state;
        }
    }
};
